exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".date-range-filter .preset-dropdown[data-v-18f6de23] {\n  position: absolute;\n  right: 0.5rem;\n  top: -0.25rem;\n}", ""]);

// exports
